import { useIsMobile } from "@/lib/hooks/use-mobile";
import { BaseNavigationBarDesktop } from "./base-navigation-bar-desktop";
import { BaseNavigationBarMobile } from "./base-navigation-bar-mobile";
import type { NavigationConfig } from "./types";

export function BaseNavigationBar(props: NavigationConfig) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <BaseNavigationBarMobile {...props} />;
  }
  return <BaseNavigationBarDesktop {...props} />;
}
